import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { MatrixRain } from "@/components/MatrixRain";
import { Logo } from "@/components/Logo";
import { NeonButton } from "@/components/Holo";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

const Field = ({ label, ...rest }) => (
  <label className="block">
    <span className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-white/50">{label}</span>
    <input {...rest} className="mt-2 w-full bg-black/30 border-b border-white/20 focus:border-neon-turquoise focus:outline-none px-1 py-2 text-white font-mono-tech text-sm transition-colors" />
  </label>
);

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Access granted, Creator.");
      navigate(u.role === "admin" ? "/admin" : "/app");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="relative min-h-screen bg-[#050505] grain flex items-center justify-center px-5 overflow-hidden">
      <div className="absolute inset-0"><MatrixRain opacity={0.18} /></div>
      <div className="absolute inset-0 cyber-grid opacity-30" />
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="relative z-10 w-full max-w-md glass clip-corner border border-white/10 p-8"
        style={{ borderTop: "1px solid rgba(0,240,255,0.6)" }} data-testid="login-card">
        <Link to="/"><Logo variant="neon" className="h-10 mb-8" /></Link>
        <h1 className="font-display font-bold text-2xl">Access Command Center</h1>
        <p className="font-mono-tech text-white/40 text-xs mt-1">Authenticate to enter FUTRA OS</p>
        <form onSubmit={submit} className="mt-8 space-y-6">
          <Field label="Email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" placeholder="creator@futra.ai" />
          <Field label="Password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" placeholder="••••••••" />
          <NeonButton accent="turquoise" type="submit" className="w-full" disabled={loading} data-testid="login-submit">
            {loading ? "Authenticating..." : "Enter FUTRA"}
          </NeonButton>
        </form>
        <p className="mt-6 font-mono-tech text-xs text-white/40">
          No credentials? <Link to="/register" className="text-neon-pink hover:underline" data-testid="to-register">Create identity</Link>
        </p>
      </motion.div>
    </div>
  );
}
